import * as React from 'react';
import { ISnowfallItem } from '@/api/resort/types';
import { MobileDataCard } from '@/components/common/MobileDataCard';
import { SectionCard } from '@/components/ui/section-card';
import { SnowUnit } from '@/components/blocks/Unit';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { cn } from '@/util/cn';

// Below md neither snowfall table fits: six columns of numbers push the
// table well past the viewport, so it either scrolls sideways or drops
// its two widest columns. Both sections swap in this card stack instead —
// one card per period, headed by the row label, with all five stats laid
// out in the card's 3-up micro-grid. Nothing is hidden on mobile.

export const MobileSnowfallCards = ({
  rows,
  labelFor,
  isHighlighted,
}: {
  rows: Array<ISnowfallItem>;
  /** Card heading — the month ("January 2025") or season ("2024 — 2025"). */
  labelFor: (item: ISnowfallItem) => React.ReactNode;
  /** Tints a card the way the table tints its row (the Annual average). */
  isHighlighted?: (item: ISnowfallItem) => boolean;
}) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className="md:hidden">
      <SectionCard as="div" padding="none" className="overflow-hidden">
        {rows.map((item) => (
          <MobileDataCard
            key={item.date}
            layout="grid"
            heading={labelFor(item)}
            className={cn(isHighlighted?.(item) && 'bg-sky-100/60')}
          >
            <MobileDataCard.Stat
              label={t('resort.historicalSnowfall.totalSnowfall')}
              value={<SnowUnit values={item.totalSnow} />}
            />
            <MobileDataCard.Stat
              label={t('resort.historicalSnowfall.snowfallDay')}
              value={t(
                item.snowDays !== 1 ? 'common.timeDay_plural' : 'common.timeDay',
                { count: item.snowDays },
              )}
            />
            <MobileDataCard.Stat
              label={t('resort.historicalSnowfall.avgBaseDepth')}
              value={<SnowUnit values={item.baseDepth} />}
            />
            <MobileDataCard.Stat
              label={t('resort.historicalSnowfall.maxBaseDepth')}
              value={<SnowUnit values={item.maxBaseDepth} />}
            />
            <MobileDataCard.Stat
              label={t('resort.historicalSnowfall.biggestSnowfall')}
              value={<SnowUnit values={item.biggestSnowfall} />}
            />
          </MobileDataCard>
        ))}
      </SectionCard>
    </div>
  );
};
